export const GUEST_LIST_DATE_FORMAT = {
  ISO_DATE: 'yyyy-MM-dd',
  DISPLAY_DATE: 'dd MMM yyyy',
} as const;

export const GUEST_LIST_TEXT = {
  SEARCH_TITLE: 'Search Bookings',
  SEARCH_BUTTON: 'Search',
  ROOM_AVAILABILITY_TITLE: 'Room Availability',
  TOTAL_GUESTS: 'Total Guests',
  ADULTS: 'Adults',
  CHILDREN: 'Children',
  DRIVERS: 'Drivers',
  SORT_BY: 'Sort by',
  NEW_BOOKING: 'New Booking',
  VIEW: 'View',
  EDIT: 'Edit',
  CLEAR_DATE: 'Clear date',
  ASCENDING: 'Ascending',
  DESCENDING: 'Descending',
  FULL: 'FULL',
  FREE: 'FREE',
  TOTAL: 'Total',
  ALLOCATED: 'Allocated',
  AVAILABLE: 'Available',
  ALL: 'All',
  EMPTY_VALUE: '-',
  CURRENCY: '₹',
  CHECKIN: 'Check-in',
  CHECKOUT: 'Check-out',
  DAYS: 'Days',
  MEMBERS: 'Members',
  ROOMS: 'Rooms',
  ADVANCE: 'Advance',
  REMAINING: 'Remaining',
  BOOKING_FOUND: (count: number) => `${count} Booking${count !== 1 ? 's' : ''} found`,
  ROOM_TYPE_FILTER: (roomType: string) => `Filter bookings by ${roomType}`,
  FILTER_FOR_ROOM: (roomType: string) => `for ${roomType}`,
  FILTER_WITH_MEMBERS: (memberLabels: string) => `with ${memberLabels}`,
} as const;

export const GUEST_LIST_ROOM = {
  OTHER_ROOM_TYPE: 'Other',
} as const;

export const GUEST_LIST_FIELD_LABEL = {
  BOOKING_DATE: 'Booking Date',
  GUEST_NAME: 'Guest Name',
  PHONE: 'Phone',
  EMAIL: 'Email',
  STATUS: 'Status',
} as const;

export const GUEST_LIST_MESSAGE = {
  FETCH_FAILED: 'Failed to fetch bookings. Please try again.',
  SEARCH_FILTER_REQUIRED: 'Enter at least one search field before searching.',
  NO_BOOKINGS_SELECTED_FILTERS: 'No bookings found for the selected filters.',
  NO_BOOKINGS_FOR_FILTERS: (roomType: string, memberLabels: string) =>
    `No bookings found${roomType ? ` for ${roomType}` : ''}${memberLabels ? ` with ${memberLabels}` : ''}.`,
} as const;

export const GUEST_LIST_MEMBER_FILTER = {
  CHILDREN: 'children',
  DRIVERS: 'drivers',
} as const;

export type GuestListMemberFilter =
  typeof GUEST_LIST_MEMBER_FILTER[keyof typeof GUEST_LIST_MEMBER_FILTER];

export const GUEST_LIST_MEMBER_FILTER_LABEL: Record<GuestListMemberFilter, string> = {
  [GUEST_LIST_MEMBER_FILTER.CHILDREN]: 'children',
  [GUEST_LIST_MEMBER_FILTER.DRIVERS]: 'drivers',
};

export const GUEST_LIST_TEST_ID = {
  SEARCH_NAME: 'search-name',
  SEARCH_BUTTON: 'search-btn',
  BUTTON_VIEW: 'btn-view',
  BUTTON_EDIT: 'btn-edit',
  MEMBER_FILTER_CHILDREN: 'member-filter-children',
  MEMBER_FILTER_DRIVERS: 'member-filter-drivers',
  ROOM_TYPE_FILTER: (roomType: string) => `room-type-filter-${roomType}`,
} as const;

export const GUEST_LIST_TABLE_COLUMN = {
  SL_NO: 'Sl No',
  NAME: 'Name',
  PHONE: 'Phone',
  CHECKIN: 'Check-in',
  CHECKOUT: 'Check-out',
  DAYS: 'Days',
  ROOM_DETAILS: 'Room Details',
  MEMBERS: 'Members',
  STATUS: 'Status',
  ADVANCE: 'Advance',
  TOTAL: 'Total',
  REMARKS: 'Remarks',
  ACTIONS: 'Actions',
} as const;

export const GUEST_LIST_SORT_KEY = {
  GUEST_NAME: 'GUEST_NAME',
  CHECKIN_DATE: 'CHECKIN_DATE',
  CHECKOUT_DATE: 'CHECKOUT_DATE',
  DAYS: 'DAYS',
  MEMBERS: 'MEMBERS',
  STATUS: 'STATUS',
  ADVANCE_AMOUNT: 'ADVANCE_AMOUNT',
  TOTAL_AMOUNT: 'TOTAL_AMOUNT',
} as const;

export const GUEST_LIST_SORT_OPTION = [
  { value: GUEST_LIST_SORT_KEY.CHECKIN_DATE, label: 'Check-in Date' },
  { value: GUEST_LIST_SORT_KEY.CHECKOUT_DATE, label: 'Check-out Date' },
  { value: GUEST_LIST_SORT_KEY.GUEST_NAME, label: 'Guest Name' },
  { value: GUEST_LIST_SORT_KEY.STATUS, label: 'Status' },
  { value: GUEST_LIST_SORT_KEY.TOTAL_AMOUNT, label: 'Total Amount' },
  { value: GUEST_LIST_SORT_KEY.ADVANCE_AMOUNT, label: 'Advance Amount' },
  { value: GUEST_LIST_SORT_KEY.MEMBERS, label: 'Members' },
  { value: GUEST_LIST_SORT_KEY.DAYS, label: 'Days' },
] as const;
